// extracted by mini-css-extract-plugin
module.exports = {"errorPage":"error_page_errorPage__2ndlC","content":"error_page_content__3GzHU","text":"error_page_text__3SnTw"};